var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-card-photo-journey-compare-photo-skeleton gc-card-photo-journey-compare__images"},[_c('AnimatedPlaceholder',{attrs:{"width":"100%","height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }